
<div class="vue-share-it-wrapper">
  <template v-for="(config, index) in finalConfig">
    <a
      :key="`share-target-${index}`"
      href="javascript:void(0)"
      @click="openPopUp(config)"
      :style="{ 
        color: (!(icons || config.icon)) ? config.color || config.defaultColor : false,
        background: (config.icon && config.backgroundColor) ? config.backgroundColor : false,
        width: (icons || config.icon) ? config.iconSize || defaultIconDimension : 'auto',
        height: (icons || config.icon) ? config.iconSize || defaultIconDimension : 'auto',
      }"
      :class="{
        'share-icon': icons || config.icon,
        'share-button': !config.icon && !icons,
        'icon-border': (icons || config.icon) && (outline || config.outline),
        'icon-border-round': (icons || config.icon) && ((outline || config.outline) || (round || config.round))
      }"
    >
      <div v-if="icons || config.icon">
        <slot :name="`${config.platform}-icon`">
          <font-awesome-icon
            :icon="[(config.defaultIcon === 'envelope') ? 'fas' : 'fab', config.defaultIcon]"
            :size="config.size || iconSize || defaultIconSize"
            :style="{ color: config.color || config.defaultIconColor || config.defaultColor }"
          />
        </slot>
      </div>
      <div v-else>
        <share-button
          :outline="outline || config.outline || false"
          :dark="dark || config.dark || false"
          :dense="dense || config.dense || false"
          :style="{ 
            color: (outline) ? config.defaultIconColor : config.color || config.defaultColor,
            background: config.backgroundColor || config.defaultBackground
          }"
        >
          <slot :name="`${config.platform}-icon`">
            <font-awesome-icon
              :icon="[(config.defaultIcon === 'envelope') ? 'fas' : 'fab', config.defaultIcon]"
              :size="config.size || defaultIconSize"
            />
          </slot>
          <slot :name="`${config.platform}-label`">
            <label>{{ config.label || config.defaultLabel }}</label>
          </slot>
        </share-button>
      </div>
    </a>
  </template>
</div>
